export default class Adjustment {
  constructor (initialData = {},) {
    const {
      _id,
      type,
      title,
      responsible,
      status,
      amount,
      company,
      city,
      occurrence,
      createdBy,
      createdAt,
      updatedAt,
      billingDate,
      competenceDate,
      value,
      statusText,
      responsibleText,
      typeText,
      transaction,
      code,
      companyName,
      companyId,
      cityName,
      userName,
      canceledBy,
      canceledAt,
      cancellationReason,
      approvedBy,
      approvedAt,
      description,
      wasConsidered,
    } = initialData;

    this.id = _id;
    this.type = type;
    this.title = title;
    this.responsible = responsible;
    this.status = status;
    this.amount = amount;
    this.company = company;
    this.city = city;
    this.createdBy = createdBy;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.occurrence = occurrence;
    this.billingDate = billingDate;
    this.competenceDate = competenceDate;
    this.value = value;
    this.statusText = statusText;
    this.responsibleText = responsibleText;
    this.typeText = typeText;
    this.transaction = transaction;
    this.code = code;
    this.companyName = companyName;
    this.companyId = companyId;
    this.cityName = cityName;
    this.userName = userName;
    this.canceledBy = canceledBy;
    this.canceledAt = canceledAt;
    this.cancellationReason = cancellationReason;
    this.approvedBy = approvedBy;
    this.approvedAt = approvedAt;
    this.description = description;
    this.wasConsidered = wasConsidered;
  }
}
